const Edit = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0013 6.66622L9.33465 3.99955M1.66797 14.3329L3.92421 14.0822C4.19987 14.0516 4.3377 14.0362 4.46653 13.9945C4.58083 13.9575 4.6896 13.9053 4.78989 13.8391C4.90294 13.7646 5.001 13.6665 5.19712 13.4704L14.0013 4.66622C14.7377 3.92984 14.7377 2.73593 14.0013 1.99955C13.2649 1.26317 12.071 1.26317 11.3347 1.99955L2.53045 10.8037C2.33433 10.9999 2.23627 11.0979 2.16173 11.211C2.09559 11.3113 2.04331 11.42 2.00631 11.5343C1.96461 11.6632 1.94929 11.801 1.91866 12.0766L1.66797 14.3329Z"
      stroke="#535862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Edit;
